import { Capacitor } from '@capacitor/core';

export function getVersionApp() {
  const androidVersion = process.env.NEXT_PUBLIC_APP_ANDROID_VERSION_NAME;
  const iosVersion = process.env.NEXT_PUBLIC_APP_IOS_VERSION_NAME;

  const platform = Capacitor.getPlatform();

  if (platform === 'web') return androidVersion;

  return platform === 'android' ? androidVersion : iosVersion;
}
